import {
  CalendarIcon,
  CheckCircleIcon,
  IssueOpenedIcon,
  IssueTrackedByIcon,
  MilestoneIcon,
  MultiSelectIcon,
  NoteIcon,
  NumberIcon,
  PersonIcon,
  RepoIcon,
  TagIcon,
  TypographyIcon,
} from '@primer/octicons-react'
import type React from 'react'

import type {FieldIconName} from './fields'

type IconComponent = React.ComponentType<{size?: number}>

const iconMap: Record<FieldIconName, IconComponent> = {
  tag: TagIcon,
  milestone: MilestoneIcon,
  person: PersonIcon,
  typography: TypographyIcon,
  'check-circle': CheckCircleIcon,
  'multi-select': MultiSelectIcon,
  calendar: CalendarIcon,
  number: NumberIcon,
  'issue-opened': IssueOpenedIcon,
  'issue-tracked-by': IssueTrackedByIcon,
  repo: RepoIcon,
}

/** Resolve a field's icon identifier to its component; fall back to a generic icon for unknown names. */
export function getFieldIcon(name: FieldIconName): IconComponent {
  return Object.hasOwn(iconMap, name) ? iconMap[name] : NoteIcon
}
